import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { theme, themeClass } from '../../constants/styling/themes';
import clearIcon from '../../assets/images/clear.svg';
import copyIcon from '../../assets/images/copy.svg';
import { noop } from 'lodash';
import { CopyToClipboard } from 'react-copy-to-clipboard';

class Input extends Component {
    _onInput = e => {
        if (this.props.isInteger) {
            e.target.value = Math.trunc(e.target.value);
        }
        if (
            this.props.onChange &&
            ((this.props.regex && this.props.regex.test(e.target.value)) || !this.props.regex || !e.target.value)
        ) {
            this.props.onChange(e.target.value, e.target.name);
        }
    };
    _onClear = () => {
        this.props.onClear();
        this.focus();
    };
    _bindInput = node => (this.inputRef = node);
    focus = (timeout = 0) => {
        setTimeout(() => this.inputRef.focus(), timeout);
    };
    _onClick = e => this.props.onClick && this.props.onClick(e);
    render() {
        return (
            <div
                className={`ckp-inputs ckp-forms-element ${this.props.icon ? 'is-with-icon' : ''} ${
                    this.props.onClear ? 'is-with-clear' : ''
                } ${this.props.className ? this.props.className : ''} ${themeClass(this.props.theme)} ${
                    this.props.disabled ? 'is-disabled' : ''
                }`}
            >
                {this.props.icon ? <img className="ckp-inputs-icon" alt="icon" src={this.props.icon} /> : null}
                <MuiThemeProvider theme={theme(this.props.theme)}>
                    <TextField
                        onClick={this._onClick}
                        inputRef={this._bindInput}
                        onChange={this._onInput}
                        value={this.props.value}
                        fullWidth
                        disabled={this.props.disabled}
                        name={this.props.name}
                        label={this.props.label}
                        className="ckp-inputs-field"
                        type={this.props.type}
                        inputProps={{
                            ...this.props.inputProps,
                            maxLength: this.props.maxLength ? this.props.maxLength : 1000
                        }}
                        helperText={
                            this.props.helperText || (this.props.showErrorMessage ? this.props.errorMessage : '')
                        }
                        error={!!this.props.errorMessage}
                        multiline={this.props.textArea}
                    />
                </MuiThemeProvider>
                {this.props.onClear && this.props.value ? (
                    <img className="ckp-inputs-clear" onClick={this._onClear} src={clearIcon} alt="clear" />
                ) : null}
                {this.props.onCopy && this.props.value ? (
                    <CopyToClipboard text={this.props.value}>
                        <img className="ckp-inputs-copy" onClick={this.props.onCopy} src={copyIcon} alt="copy" />
                    </CopyToClipboard>
                ) : null}
            </div>
        );
    }
}

Input.defaultProps = { type: 'text', onChange: noop, showErrorMessage: true };

export default Input;
